module.exports = __webpack_public_path__ + "krecove-zily_2_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/obecna-a-zilni-chirurgie/krecove-zily_2_after_tn.jpg
// module id = 1495
// module chunks = 0